import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import { Moment } from "moment";
import moment from "moment";
import {
  Check2Icon,
  ChooseIcon,
  DeliveredIcon,
  LockIcon,
  OffIcon,
  PrepareIcon,
  Restaurant2Icon,
  RestaurantIcon,
  SelectedDisabledIcon,
  SelectedIcon,
} from "../../assets/icons";
import { CommonProps } from "@mui/material/OverridableComponent";
import { checkIf, defaultFormat } from "../../utils";
import { DeliveryAddressCalendarResponse, DeliveryAddressCalendarResponseStatusEnum } from "../../openapi/client";

import { DateSelection, IAddressResponse } from "../../pages/UserDetail";
import { Box, Tooltip, Typography } from "@mui/material";
import theme from "../../theme";

export default function CustomDay(
  props: PickersDayProps<Moment> & {
    addresslist?: IAddressResponse[];
    deliveryinfo?: DeliveryAddressCalendarResponse[];
    activeaddress?: string;
  }
) {
  const { day, outsideCurrentMonth, addresslist, today, selected, classes, ...other } = props;
  const targetDay = props.deliveryinfo?.find((i) => i.date === day.format(defaultFormat));
  const past = day.isBefore(moment().startOf("day"));

  const targetDayStatus = targetDay?.status;

  const targetDeliveryDay = props.deliveryinfo?.find((i) => i.date === day.format(defaultFormat));

  const selectedForDelivery =
    targetDeliveryDay?.status === DeliveryAddressCalendarResponseStatusEnum.Selected &&
    targetDeliveryDay?.addressId === props.activeaddress;

  const assignedToAnotherAddress =
    targetDeliveryDay?.status === DeliveryAddressCalendarResponseStatusEnum.Selected &&
    targetDeliveryDay?.addressId !== props.activeaddress;

  const assignedAddress = addresslist?.find((i) => i.id === targetDeliveryDay?.addressId)?.name;

  const className = `${selected ? "selected" : ""} ${today ? "today" : ""} ${
    assignedToAnotherAddress ? "assignedToAnotherAddress" : ""
  } ${past ? "past" : ""} ${selectedForDelivery ? "selectedForDelivery" : ""}`;

  // console.log("delivery rendered", props.deliveryInfo);
  // console.log("props.activeAddress", props.activeAddress);
  // console.log("classes", classes);
  // console.log("classname", className);
  // console.log("addressList", addresslist);
  // console.log("day of month", day.format("D"));
  // console.log("selectedPlan", selectedPlan);
  // console.log("props.daysInfo", props.daysinfo);
  //   const isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;
  //   const status = props.daysinfo?.find((info: any) => info.date === props.day.format(defaultFormat))
  //     ?.status as PlanDayResponseStatusEnum;

  const handleDaySelect = (day: Moment) => {
    if (!outsideCurrentMonth && assignedToAnotherAddress) {
      props.onDaySelect(day);
    }
  };

  let Icon;
  let disabled;
  let tooltipTitle = "";

  switch (targetDayStatus) {
    case DeliveryAddressCalendarResponseStatusEnum.Unselectable:
      Icon = <LockIcon color={theme.palette.text.gray} />;
      tooltipTitle = "Not a deliverable day";
      break;
    case DeliveryAddressCalendarResponseStatusEnum.Locked:
      Icon = <Restaurant2Icon color={theme.palette.text.blue} />;
      tooltipTitle = "Not a changeable day";
      break;
    case DeliveryAddressCalendarResponseStatusEnum.Selected:
      if (selectedForDelivery) {
        Icon = <Check2Icon color={theme.palette.primary.main} />;
      }
      break;
    default:
      disabled = false;
      break;
  }

  if (assignedToAnotherAddress) {
    tooltipTitle = `Will be delivered to ${assignedAddress}`;
  } else if (selectedForDelivery) {
    tooltipTitle = "Will be delivered to the selected address";
  }

  //   const { icon, className, explanation } = getStatusInfo(status);

  return (
    <PickersDay
      key={props.day.format(defaultFormat)}
      {...other}
      disabled={other.disabled || disabled}
      classes={classes}
      className={className}
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      onDaySelect={handleDaySelect}
      sx={{
        height: "55px",
        // "&.today > span.MuiTypography-root": { border: "2px solid #FF8F0B" },
        "&.selected": { backgroundColor: "rgba(255, 143, 11, 0.08)" },
        // "&.past": { opacity: "0.25" },
        "&.selectedForDelivery": {
          background: "linear-gradient(0deg, rgba(44, 187, 76, 0.03) 0%, rgba(44, 187, 76, 0.03) 100%)",
        },
        "&.selectedForDelivery > span": {
          fontWeight: 600,
        },
        "&.MuiPickersDay-dayOutsideMonth": {
          pointerEvents: "none",
        },
        "&.MuiPickersDay-dayOutsideMonth > span": {
          color: "text.fontLight3",
          opacity: "0.25",
        },
      }}
    >
      <Tooltip title={tooltipTitle} placement="top" arrow>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ fontSize: "12px", color: "#000", lineHeight: "normal" }} component={"span"}>
            {day.format("D")}
          </Typography>
          <Box sx={{ position: "absolute", top: "2px", right: "2px" }}>{Icon}</Box>
        </Box>
      </Tooltip>
    </PickersDay>
  );
}
